export const recentEvents = [
    {
        id: "recent1",
        src: "./images/events/26jan_2026.jpg",
        alt: "26 January Guard of Honour",
        title: "26 January Guard of Honour"
    },
    {
        id: "recent2", 
        src: "./images/events/votersday26.jpeg",
        alt: "National Voters Day 2026",
        title: "National Voters Day competition",
        link: "https://channeli.in/noticeboard/notice/19230"
    },
    {
        id: "recent3",
        src: "./images/events/gc.jpg", 
        alt: "Group Commander Lecture 16th Oct",
        title: "Guest Lecture by Group Commander"
    },
    {
        id: "recent4",
        src: "./images/events/BDC.jpg",
        alt: "Blood Donation Camp", 
        title: "Blood Donation Camp 2025"
    }
];
